// extracted by mini-css-extract-plugin
module.exports = {"CutCosts-detail":"CutCosts_CutCosts-detail__4ea_W"};